import $ from 'jquery'
import Base from 'luminate/src/modules/base'
import Toggler from 'luminate/src/modules/toggler'

export default Toggler.extend({
	directive: 'lightbox',

	modules: {
		containers: Base.extend({
			directive: 'container',
			methods: {
				setContent(html)
				{
					this.$element.innerHTML = html
				}
			}
		})
	},

	methods: {

		close()
		{
			Toggler.methods.close.apply(this, arguments)

			for(let container of this.$owns.containers)
			{
				container.setContent('')
			}
		}
	},

	events: {

		init()
		{
			this.on('methodCall', e =>
			{
				if(e.name == 'open')
				{
					const html = $(e.caller.$element).attr('lightbox-content')

					for(let container of this.$owns.containers)
					{
						container.setContent(html)
					}
				}
			})
		}
	}
})


/** WEBPACK FOOTER **
 ** ./source/scripts/modules/lightbox.js
 **/